import React, { useState } from 'react';
import {
  Table,
  Button,
  Input,
  Select,
  Popconfirm,
  Space,
  Card,
  message,
} from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { useMutation, useQuery } from '@tanstack/react-query';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getSearchApi } from '../../../network/itemList';
import { getPaymentReferences } from '../../../network/PaymentEntry';

const PaymentReferencesList = ({
  watchPartyId,
  isStatusDisabledFiled,
  sales,
  setValueReferenceType,
  setDataSourceReference,
  dataSourceReference,
  t,
}) => {
  const [count, setCount] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { mutate: onGetPaymentReferences, reset: resetGetPaymentReferences } =
    useMutation({
      mutationKey: [queryKeys.getPaymentReferences],
      mutationFn: ({ id, type }) => getPaymentReferences(id, type),
      onSuccess: (data) => {
        // console.log(data, 'data');
        const newDataSource = [...dataSourceReference];
        newDataSource[selectedIndex] = {
          ...newDataSource[selectedIndex],
          paymentReferencesName: data?.message?.references,
        };
        setDataSourceReference(newDataSource);
      },
    });
  const columns = [
    {
      title: t.type,
      dataIndex: 'reference_doctype',
      render: (text, record, index) => (
        <Select
          placeholder={t.type}
          value={record?.reference_doctype}
          style={{ width: '200px' }}
          disabled={isStatusDisabledFiled || !!sales}
          popupMatchSelectWidth={false}
          options={[
            {
              value: 'Sales Invoice',
              label: t.salesInvoice,
            },
            {
              value: 'Sales Order',
              label: t.SalesOrder,
            },
            {
              value: 'Duning',
              label: t.Duning,
            },
            {
              value: 'Journal Entry',
              label: t.JournalEntry,
            },
          ]}
          onChange={(value, option) => {
            setSelectedIndex(index);
            if (watchPartyId) {
              onGetPaymentReferences({ id: watchPartyId, type: value });
            }
            const newDataSource = [...dataSourceReference];
            newDataSource[index] = {
              ...newDataSource[index],
              reference_doctype: value,
            };
            setDataSourceReference(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.Name,
      dataIndex: 'reference_name',
      render: (text, record, index) => (
        <Select
          placeholder={t.Name}
          value={record?.reference_name}
          style={{ width: '200px' }}
          popupMatchSelectWidth={false}
          options={
            record?.paymentReferencesName?.length
              ? record?.paymentReferencesName?.map((account) => ({
                  value: account?.name,
                  label: account?.name,
                  option: account,
                }))
              : []
          }
          onChange={(value, option) => {
            console.log(option, 'option');
            const newDataSource = [...dataSourceReference];
            newDataSource[index] = {
              ...newDataSource[index],
              reference_name: value,
              total_amount: option?.option?.grand_total,
              outstanding_amount: option?.option?.outstanding_amount,
            };
            setDataSourceReference(newDataSource);
          }}
        />
      ),
    },
    {
      title: t.GrandTotal,
      dataIndex: 'total_amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.GrandTotal}
          type="number"
          value={record.total_amount}
          style={{ width: '200px' }}
          disabled
        />
      ),
    },
    {
      title: t.Outstanding,
      dataIndex: 'outstanding_amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.Outstanding}
          type="number"
          value={record.outstanding_amount}
          style={{ width: '200px' }}
          disabled
        />
      ),
    },
    {
      title: t.Allocated,
      dataIndex: 'allocated_amount',
      render: (text, record, index) => (
        <Input
          placeholder={t.Allocated}
          type="number"
          value={record.allocated_amount}
          style={{ width: '200px' }}
          onChange={(e) => {
            if (e.target.value > record.outstanding_amount) {
              message.error(t.allocatedAmountGreaterThanOutstanding);
              return;
            }
            const newDataSource = [...dataSourceReference];
            newDataSource[index] = {
              ...newDataSource[index],
              allocated_amount: e.target.value,
            };
            setDataSourceReference(newDataSource);
          }}
          max={record.outstanding_amount}
        />
      ),
    },
    {
      title: t.action,
      key: 'action',
      render: (text, record, index) => (
        <Space>
          <Popconfirm
            title={t.confirmDelete}
            onConfirm={() => handleDelete(record.key)}
          >
            <Button
              type="primary"
              danger
              icon={<DeleteOutlined />}
              size="small"
            />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  const handleAdd = () => {
    const newData = {
      key: count,
    };
    setDataSourceReference([...dataSourceReference, newData]);
    setCount(count + 1);
  };

  const handleDelete = (key) => {
    const newDataSource = dataSourceReference.filter(
      (item) => item.key !== key
    );
    setDataSourceReference(newDataSource);
  };

  return (
    <Card>
      <Table
        className="table_custom"
        dataSource={dataSourceReference}
        columns={columns}
        pagination={{ hideOnSinglePage: true }}
        scroll={{ x: 'max-content' }}
        rowKey="key"
      />
      <Button
        onClick={handleAdd}
        type="primary"
        ghost
        style={{ marginTop: '20px', borderRadius: '6px' }}
        icon={<PlusOutlined />}
        size="small"
      >
        {t.addRow}
      </Button>
    </Card>
  );
};

export default PaymentReferencesList;
